import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  newMeetingInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  titleText: {
    color: theme.palette.facet.primaryBlue,
    fontWeight: theme.typography.fontWeightMedium,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  attendeesContainer: {
    marginTop: theme.spacing(2),
  },
  descriptionContainer: {},
  descriptionLabel: {
    color: theme.palette.facet.primaryBlue,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '0.8rem',
  },
  descriptionTextarea: {
    height: 100,
  },
});

const ConfirmTimeLayout = ({
  className,
  classes,
}) => {
  const { resource: calendarEventResource } = useMetaLayoutContext();
  const tz = moment.tz.guess();
  const isMobile = useMobileLayout();

  const meetingTitle = calendarEventResource.attr('title');
  const calendarEventStart = moment(calendarEventResource.attr('startTime')).tz(tz);
  const dateTitle = calendarEventStart.format('dddd MMMM Do');
  const timeTitle = calendarEventStart.format('h:mmA z');

  return (
    <div className={classNames(classes.root, className)}>
      {!isMobile && (
        <Typography variant="h3" className={classes.titleText}>
          {meetingTitle}
        </Typography>
      )}
      <div className={classes.newMeetingInfo}>
        <Typography variant="h3" className={classes.titleText} test="new-meeting-date-header">
          <strong>Date:</strong> {dateTitle}
        </Typography>
        <Typography variant="h3" className={classes.titleText}>
          <strong>Time:</strong> {timeTitle}
        </Typography>
      </div>
      <div className={classes.attendeesContainer}>
        <MetaControlField attr="attendees" />
      </div>
      <div className={classes.descriptionContainer}>
        <MetaControlField
          attr="description"
        />
      </div>
    </div>
  );
};

ConfirmTimeLayout.defaultProps = {
  className: '',
};

ConfirmTimeLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ConfirmTimeLayout);
